export function initialFrontendAuthenticationState() {
    if (typeof document === 'undefined') return null

    const value = document.querySelector('meta[name="authenticated"]')?.content

    if (value === '1') return true
    if (value === '0') return false

    return null
}

export function initialFrontendAdminState() {
    if (typeof document === 'undefined') return false

    return document.querySelector('meta[name="frontend-admin"]')?.content === '1'
}
